webpackJsonp([0,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Format = {
	  type: {
	    required: {
	      reg: /.{1,}/,
	      msg: '此项不能为空'
	    },
	    email: {
	      reg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
	      msg: '邮箱格式错误'
	    },
	    phone: {
	      reg: /^\d{11}$/,
	      msg: '手机格式错误'
	    },
	    float: {
	      reg: /^\d+(.\d+)?$/,
	      msg: '必须为整数或小数'
	    },
	    int: {
	      reg: /^\d+$/,
	      msg: '必须为整数'
	    }
	  },
	  do: function _do(required, format, value) {
	    var _this = this;
	    var pass = { state: true, msg: '' };
	    try {
	      if (typeof value === 'string') {
	        var value = value.replace(/\s/, '');
	      }
	    } catch (e) {
	      return {
	        state: false,
	        msg: '验证发生错误'
	      };
	    }
	
	    if (required) {
	      if (!_this.type.required.reg.test(value)) {
	        return {
	          state: false,
	          msg: _this.type.required.msg
	        };
	      }
	    }
	
	    if (typeof format === 'string') {
	      var tester = _this.type[format];
	    } else {
	      var tester = format;
	    }
	
	    if (tester == undefined) {
	      return pass;
	    }
	
	    if (tester.reg.test(value)) {
	      return pass;
	    } else {
	      if (value == '') {
	        return pass;
	      }
	      return {
	        state: false,
	        msg: tester.msg
	      };
	    }
	  }
	};
	
	module.exports = Format;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formInput',
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    holder: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    },
	    focus: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, this.format, this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    },
	    handleClick: function handleClick() {
	      this.$emit('on-click', '');
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	  mounted: function mounted() {
	    if (this.focus) {
	      this.$refs.input.focus();
	    }
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    },
	    valueSelf: function valueSelf(newval) {
	      this.$emit('input', newval);
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(104),
	  /* template */
	  __webpack_require__(251),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boInput = __webpack_require__(10);
	
	var _boInput2 = _interopRequireDefault(_boInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: '',
	  components: {
	    BoInput: _boInput2.default
	  },
	  methods: {
	    getValue: function getValue() {
	      alert(this.$refs.test.getValue());
	    },
	    setState: function setState(state) {
	      this.$refs.test.setState(state);
	    },
	    verify: function verify() {
	      alert(this.$refs.test.verify().msg);
	    }
	  },
	  data: function data() {
	    return {
	      val: 'hello world'
	    };
	  }
	};

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {
	    staticClass: "p2222"
	  }, [_c('div', {
	    staticClass: "tl"
	  }, [_vm._v("\n      " + _vm._s(_vm.val) + "\n    ")]), _vm._v(" "), _c('bo-input', {
	    ref: "test",
	    attrs: {
	      "holder": "请输入内容",
	      "required": true,
	      "size": "lg",
	      "focus": ""
	    },
	    model: {
	      value: (_vm.val),
	      callback: function($$v) {
	        _vm.val = $$v
	      },
	      expression: "val"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "p1000 tl"
	  }, [_c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": _vm.getValue
	    }
	  }, [_vm._v("获取输入值")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": function($event) {
	        _vm.setState('wrong')
	      }
	    }
	  }, [_vm._v("置为警告")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": function($event) {
	        _vm.setState('pass')
	      }
	    }
	  }, [_vm._v("置为通过")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": _vm.verify
	    }
	  }, [_vm._v("验证")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "row p2222"
	  }, [_c('bo-input', {
	    attrs: {
	      "holder": "Large Size",
	      "size": "lg",
	      "icon": "scan"
	    }
	  }), _vm._v(" "), _c('bo-input', {
	    style: ({
	      marginTop: '10px'
	    }),
	    attrs: {
	      "holder": "请输入内容",
	      "size": "lg",
	      "state": "wrong",
	      "value": "一段内容"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row p1010"
	  }, [_c('bo-input', {
	    attrs: {
	      "holder": "请输入内容",
	      "size": "lg",
	      "theme": "underline"
	    }
	  }), _vm._v(" "), _c('bo-input', {
	    style: ({
	      marginTop: '10px'
	    }),
	    attrs: {
	      "holder": "请输入内容",
	      "state": "pass",
	      "size": "lg",
	      "theme": "underline"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row p2000"
	  }, [_c('bo-input', {
	    attrs: {
	      "holder": "请输入内容",
	      "label": "账 号",
	      "theme": "blank",
	      "size": "lg"
	    }
	  }), _vm._v(" "), _c('bo-input', {
	    attrs: {
	      "holder": "请输入内容",
	      "label": "密 码",
	      "theme": "blank",
	      "size": "lg"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row p2000"
	  }, [_c('bo-input', {
	    attrs: {
	      "holder": "请输入内容",
	      "label": "账 号",
	      "theme": "head",
	      "size": "lg"
	    }
	  }), _vm._v(" "), _c('bo-input', {
	    attrs: {
	      "holder": "请输入内容",
	      "label": "密 码",
	      "theme": "head",
	      "size": "lg"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.fb56685640b5f8ec60e0.js